import React from "react";

const testimonials = [
  {
    name: "Shantanu Kumar",
    title: "Product Expert, Smith Applied Solutions",
    feedback:
      "Smart Nexus Solutions transformed our business operations. Their automation solutions saved us hours every week and increased our team’s productivity by 40%.",
  },
  {
    name: "Rohan Sinha",
    title: "Marketing Manager, Green Valley Realtors",
    feedback:
      "The AI-powered customer support assistant has been a game-changer for us. Our response time has improved drastically, and our clients love the 24/7 support.",
  },
  {
    name: "David Lee",
    title: "Founder, Precision Manufacturing",
    feedback:
      "Their AI automation helped us streamline our inventory management process and reduce human errors significantly. I highly recommend them!",
  },
];

const Testimonials = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">
          What Our Clients Say
        </h2>
        <p className="mt-2 text-center text-lg text-gray-600">
          Real stories from satisfied clients
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white shadow rounded-lg p-6 flex flex-col justify-between"
            >
              <p className="text-gray-700 italic mb-4">
                "{testimonial.feedback}"
              </p>
              <div className="flex items-center mt-4">
                {/* <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full mr-4"
                /> */}
                <div>
                  <p className="font-semibold text-gray-900">{testimonial.name}</p>
                  <p className="text-sm text-gray-500">{testimonial.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
